import { render, staticRenderFns } from "./OutingDetail.vue?vue&type=template&id=324ff1fe&scoped=true&lang=pug"
import script from "./OutingDetail.vue?vue&type=script&lang=ts"
export * from "./OutingDetail.vue?vue&type=script&lang=ts"
import style0 from "./OutingDetail.vue?vue&type=style&index=0&id=324ff1fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324ff1fe",
  null
  
)

export default component.exports